import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const PathContext = createContext();

export const PathProvider = ({ children }) => {
  const [pathHistory, setPathHistory] = useState([]);
  const location = useLocation();

  useEffect(() => {
    setPathHistory((prev) => [...prev, location.pathname]);
  }, [location.pathname]);

  const getPreviousPath = () => {
    return pathHistory[pathHistory.length - 1] || null;
  };

  return (
    <PathContext.Provider value={{ pathHistory, getPreviousPath }}>
      {children}
    </PathContext.Provider>
  );
};
